import axios, { AxiosResponse } from "axios";
import { UserApiData } from "../models/user-model";
import { configService } from "./config.service";
import { getApiUsersCurrent } from "../../../api/axios/getApiUsersCurrent";
import { putApiUsersById } from "../../../api/axios/putApiUsersById";
import { useUser } from "../../../composables/apiModels/useUser";

class UserService {

  async updateCurrentUser(user: UserApiData): Promise<UserApiData> {
    const { convertToPutObject } = useUser();
    const response = await putApiUsersById(user.id ?? -1, convertToPutObject(user));
    if (!response.data) {
      throw new Error("User not found");
    }
    return response.data as UserApiData;
  }

  public async fetchCurrentUser(): Promise<UserApiData> {
    const response = await getApiUsersCurrent();
    return response.data as UserApiData;
  }

  public setCurrentInstitution(institutionCode: number, role: number): Promise<any> {
    return new Promise<UserApiData>((resolve, reject) => {
      axios
        .post(
          configService.APIUrl("select_institution.json?code=" + institutionCode + "&role=" + role)
        )
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async changePassword(query: { password: string; new_password: string }): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      axios
        .post(configService.APIUrl("change_password.json"), query)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

// export a singleton instance in the global namespace
export const userService: UserService = new UserService();
